export default {
  tc: {
    loginHappyFan: '用戶登入',
    phone: '手提電話號碼 *',
    verificationCode: '驗證碼 *',
    getSMSCode: '獲取SMS驗證碼',
    codeSent: '已傳送驗證碼',
    login: '登入',
    registerNow: '立即登記',
  },
  sc: {
    loginHappyFan: '用户登入',
    phone: '流动电话号码 *',
    verificationCode: '验证码 *',
    getSMSCode: '获取SMS验证码',
    codeSent: '已发送验证码',
    login: '登入',
    registerNow: '立即登记',
  },
  en: {
    loginHappyFan: 'User Login',
    phone: 'Mobile phone no. *',
    verificationCode: 'Verification code *',
    getSMSCode: 'Get SMS verification code',
    codeSent: 'Verification code sent',
    login: 'Login',
    registerNow: 'Register Now',
  }
};